import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, KYVIXE } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (localStorage.getItem("kyvixe_token")) nav("/admin", { replace: true });
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("kyvixe_token", r.data.token);
      localStorage.setItem("kyvixe_email", r.data.email);
      toast.success("Signed in.");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-hero-glow flex items-center justify-center px-6 py-20" data-testid="admin-login-page">
      <form onSubmit={submit} className="kyv-card w-full max-w-md p-8 space-y-5">
        <Link to="/" className="flex items-center justify-center gap-2 mb-4">
          <span className="font-display text-3xl font-bold lowercase tracking-tighter">
            kyvixe<span className="text-blue-500">.</span>
          </span>
        </Link>
        <div className="text-center">
          <div className="p-3 rounded-full bg-blue-500/10 text-blue-400 w-fit mx-auto mb-3">
            <Lock size={18} />
          </div>
          <h1 className="font-display lowercase font-bold text-3xl tracking-tight">
            admin sign in
          </h1>
          <p className="text-sm text-gray-400 mt-2">
            protected area. leads, bookings and blog.
          </p>
        </div>
        <div className="space-y-3">
          <div>
            <label className="text-xs text-gray-400 lowercase">email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              className="mt-1 w-full bg-white/5 border border-white/10 rounded-xl px-3 py-2.5 text-sm text-white focus:outline-none focus:border-blue-500/60"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="text-xs text-gray-400 lowercase">password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 w-full bg-white/5 border border-white/10 rounded-xl px-3 py-2.5 text-sm text-white focus:outline-none focus:border-blue-500/60"
              data-testid="admin-password-input"
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="kyv-btn-primary w-full flex items-center justify-center gap-2 disabled:opacity-60"
          data-testid="admin-login-submit-btn"
        >
          {loading && <Loader2 size={16} className="animate-spin" />} sign in
        </button>
        <Link to="/" className="block text-center text-xs text-gray-500 hover:text-blue-400">
          back to site
        </Link>
      </form>
    </div>
  );
}
